import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import CloseIcon from '@material-ui/icons/Close';
import Rating from '@material-ui/lab/Rating';
import { useSnackbar } from 'notistack';

import {
  TextInput,
  IntegerInput,
  AutoCompleteRemoto,
} from '../../../Components';
import { createAPI, updateAPI, getListAllAPI } from '../../../services';
import { STATUS_ATIVO } from '../../../utils';
import LocaisInput from '../../Colaboradores/LocaisInput';
import AreaInput from '../AreaInput';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    // color: theme.palette.grey[500],
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const DEFAULT_ID = -1;

const DialogoCategoriaTransacao = forwardRef(({ handleClose }, ref) => {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [nome, setNome] = useState('');
  const [area, setArea] = useState(0);
  const [colaboradores, setColaboradores] = useState([]);
  const [colaboradoresOptions, setColaboradoresOptions] = useState([]);

  const [id, setId] = useState(DEFAULT_ID);

  const [carregando, setCarregando] = useState(false);

  const classes = useStyles({ cor: '#009FD4' });

  useEffect(() => {
    async function getDadosLocais() {
      try {
        const data = await getListAllAPI(
          'colaboradores',
          ['id', 'asc'],
          { status: STATUS_ATIVO },
          [],
        );
        setColaboradoresOptions(data.data);
      } catch (erros) {
        enqueueSnackbar(`${erros}`, {
          variant: 'error',
        });
        handleCloseDialog();
      }
    }
    if (open) getDadosLocais();
  }, [open]);

  const handleCloseDialog = () => {
    setOpen(false);
    handleClose();
  };

  async function reiniciar() {
    setId(DEFAULT_ID);
    setNome('');
    setArea(0);
    setCarregando(false);
    setColaboradores([]);

    /* const dataSetores = await getListAllAPI(
      'locais_setores',
      ['id', 'asc'],
      {},
      [],
    );

    setLocaisOptions(filtrarLocais(dataSetores.data, -1)); */
  }

  /* function filtrarLocais(locais, colaborador_id) {
    const novoLocais = [];
    for (let i = 0; i < locais.length; i += 1) {
      if (
        locais.colaborador_id === colaborador_id ||
        locais.colaborador_id === null
      ) {
        novoLocais.push(novoLocais);
      }
    }
    return novoLocais;
  } */

  async function getDataResource(id) {
    try {
      const data = await getListAllAPI(
        'locais_setores',
        ['id', 'asc'],
        { id: [id] },
        ['colaboradores'],
      );

      /* const dataSetores = await getListAllAPI(
        'locais_setores',
        ['id', 'asc'],
        {},
        [],
      ); */

      /* setLocaisOptions(filtrarLocais(dataSetores.data, id)); */

      if (data.data.length > 0) {
        setId(data.data[0].id);
        setNome(data.data[0].nome);
        setArea(data.data[0].area);
        setColaboradores(data.data[0].colaboradores);
        setCarregando(false);
      } else {
        throw 'Este local não existe!';
      }
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog();
    }
  }

  function getIdsOptions() {
    const ids = [];
    for (let i = 0; i < colaboradores.length; i += 1) {
      ids.push(colaboradores[i].id);
    }
    return ids;
  }

  async function handleSalvar() {
    setCarregando(true);
    try {
      if (id <= 0) {
        await createAPI('locais_setores', {
          nome,
          area,
          colaboradores: getIdsOptions(),
        });
        setCarregando(false);
        enqueueSnackbar('Local criado com sucesso!', {
          variant: 'success',
        });
      } else {
        await updateAPI('locais_setores', id, {
          nome,
          area,
          colaboradores: getIdsOptions(),
        });
        setCarregando(false);
        enqueueSnackbar('Local atualizado com sucesso!', {
          variant: 'success',
        });
      }

      handleCloseDialog();
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog();
    }
  }

  useImperativeHandle(ref, () => ({
    handleCreate() {
      reiniciar();
      setOpen(true);
    },
    handleEdit(id) {
      setCarregando(true);
      getDataResource(id);
      setId(id);
      setOpen(true);
    },
  }));

  function validateNome() {
    let error = '';
    if (!nome) error = 'Este campo é obrigatório';
    else if (nome.length > 80) {
      error = 'Número de caracteres maior que o permitido (máximo 80)';
    }
    return error;
  }

  function validateArea() {
    let error = '';
    if (area) {
      if (area <= 0 || Number.isNaN(area)) {
        error = 'Este campo é obrigatório!';
      }
    }
    return error;
  }

  function getErros() {
    const errosOld = ['', '', ''];
    errosOld[0] = validateNome();
    errosOld[1] = validateArea();
    return errosOld;
  }

  const erros = getErros();

  function hasError() {
    for (let i = 0; i < erros.length; i += 1) {
      if (erros[i] !== '') return true;
    }
    return false;
  }

  const erroExistente = hasError();

  const marginLine = 2;

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        classes={{ paper: classes.rootDialogo }}
        className={classes.rootDialogo}
        fullWidth
        maxWidth="sm"
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle
          id="form-dialog-title"
          onClose={handleCloseDialog}
          style={{ backgroundColor: '#009FD4', color: 'white' }}
        >
          {id < 0 ? `Novo Colaborador` : `Editar Colaborador`}
        </DialogTitle>
        <DialogContent
          style={{
            padding: '0px 36px 20px',
            margin: '0',
          }}
        >
          {carregando ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <div>
              <Box
                component="fieldset"
                mb={marginLine}
                borderColor="transparent"
              >
                <TextInput
                  name="nome"
                  handleEnter={() => {}}
                  label="Nome"
                  handleKey={() => {}}
                  value={nome}
                  onChange={(value) => setNome(value.target.value)}
                  error={erros[0] !== ''}
                  helperText={erros[0]}
                  fullWidth
                />
              </Box>

              <Box
                component="fieldset"
                mb={marginLine}
                borderColor="transparent"
              >
                <AreaInput
                  name="area"
                  handleEnter={() => {}}
                  label="Área"
                  handleKey={() => {}}
                  value={Number.isNaN(area) ? '' : String(area)}
                  onChange={(value) =>
                    setArea(parseFloat(value.target.value, 10))
                  }
                  error={erros[1] !== ''}
                  helperText={erros[1]}
                  fullWidth
                />
              </Box>

              <Box
                component="fieldset"
                mb={marginLine}
                borderColor="transparent"
              >
                <LocaisInput
                  label="Colaboradores"
                  options={colaboradoresOptions}
                  value={colaboradores}
                  onChange={setColaboradores}
                />
              </Box>
            </div>
          )}
        </DialogContent>
        <DialogActions
          style={{
            padding: '0px 36px 20px',
            margin: '0',
          }}
        >
          <div className={classes.wrapper}>
            <Button
              onClick={handleSalvar}
              classes={{
                root: classes.btnAtions,
                disabled: classes.btnAtionsDisabled,
              }}
              disabled={erroExistente || carregando}
              variant="contained"
              color="primary"
            >
              Salvar
            </Button>
            {carregando && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
});

export default DialogoCategoriaTransacao;
